(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["classic-handle-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('[data-measure-dialog]');
      const opener = root.querySelector('[data-measure-open]');
      let returnFocus;
      opener?.addEventListener('click', () => {
        returnFocus = document.activeElement;
        dialog?.showModal();
      });
      root.querySelectorAll('[data-measure-close]').forEach((button) => button.addEventListener('click', () => dialog?.close()));
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog?.addEventListener('close', () => returnFocus?.focus());
    };
    const parseSize = (value = '') => {
      const [imperialPart = '', metricPart = ''] = value.split('(');
      const imperialValues = imperialPart.split('/');
      const metricValues = metricPart.replace(')', '').split('/');
      const overallImperial = (imperialValues[0] || '').replace(/\bOVERALL\b/i, '').trim();
      const centerImperial = (imperialValues[1] || '').replace(/\bCTC\b/i, '').trim();
      const addMetric = (imperial, metric) => {
        const cleanMetric = (metric || '').trim();
        const formattedMetric = cleanMetric && !/mm$/i.test(cleanMetric) ? `${cleanMetric} MM` : cleanMetric;
        return [imperial, formattedMetric].filter(Boolean).join(' / ');
      };
      return {
        overall_length: addMetric(overallImperial, metricValues[0]),
        center_to_center: addMetric(centerImperial, metricValues[1]),
      };
    };
    const updateSpecs = (sectionId, variant) => {
      const root = document.querySelector(`[data-fh-classic="${sectionId}"]`);
      if (!root || !variant) return;
      const map = JSON.parse(root.querySelector('[data-variant-specs]')?.textContent || '{}');
      const specs = map[String(variant.id)];
      if (!specs) return;
      const values = { finish: specs.finish, material: specs.material, ...parseSize(specs.size) };
      Object.entries(values).forEach(([key, value]) => {
        const row = root.querySelector(`[data-spec-row="${key}"]`);
        const target = root.querySelector(`[data-spec="${key}"]`);
        if (target) target.textContent = value || '';
        if (row) row.hidden = !value;
      });
    };
    document.querySelectorAll('[data-fh-classic]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-fh-classic]').forEach(initialize));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => updateSpecs(data?.sectionId, data?.variant));
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
